import { render, staticRenderFns } from "./qualityInspectionManage.vue?vue&type=template&id=1cec3720&scoped=true"
import script from "./qualityInspectionManage.vue?vue&type=script&lang=js"
export * from "./qualityInspectionManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cec3720",
  null
  
)

export default component.exports